import * as ROUTES from '../backend-routes'
import { executePatch, executePost } from '../requests/axios'

export const checkUser = function (username, onSuccess, onError) {
  const payload = JSON.stringify({ username: username })

  executePost(ROUTES.LOGIN.PATH_CHECK_USER, payload, onSuccess, onError)
}

export const authenticateWithPassword = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_PASSWORD, payload, onSuccess, onError)
}

export const authenticateWithOtp = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_OTP, payload, onSuccess, onError)
}

export const authenticateWithMme = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_MME_LOGIN, payload, onSuccess, onError)
}

export const saveConsent = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_CONSENT_SCOPES, payload, onSuccess, onError)
}

export const setCountry = function (uid, payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_SET_COUNTRY + uid, payload, onSuccess, onError)
}

export const setPassword = function (payload, onSuccess, onError) {
  executePatch(ROUTES.LOGIN.PATH_PASSWORD, payload, onSuccess, onError)
}

export const getAuthState = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_GET_AUTH_STATE, payload, onSuccess, onError)
}

export const setEmail = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_SET_EMAIL, payload, onSuccess, onError)
}

export const setMobile = function (payload, onSuccess, onError) {
  executePost(ROUTES.LOGIN.PATH_SET_MOBILE, payload, onSuccess, onError)
}
